export function caseInsensitiveObject<T extends object>(obj: T): T {
  return new Proxy(obj, {
    get(target, prop) {
      if (typeof prop !== 'string') {
        return target[prop as keyof T];
      }

      if (prop in target) {
        return target[prop as keyof T];
      }

      const key = Object.keys(target).find(
        (k) => k.toLowerCase() === prop.toLowerCase(),
      );

      return key ? target[key as keyof T] : undefined;
    },
  });
}

export function caseInsensitivePick<T extends object>(
  obj: unknown,
  keys: readonly (keyof T & string)[],
): T {
  const source =
    obj && typeof obj === 'object'
      ? caseInsensitiveObject(obj as Record<string, unknown>)
      : ({} as Record<string, unknown>);

  return keys.reduce(
    (result, key) => ({
      ...result,
      [key]: source[key],
    }),
    {} as T,
  );
}

export function caseInsensitivePickArray<T extends object>(
  value: unknown,
  keys: readonly (keyof T & string)[],
): T[] {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.map((item) => caseInsensitivePick<T>(item, keys));
}
